export default "__VITE_ASSET__ee1dd5ab__"